import { render, staticRenderFns } from "./salesOrderLineDetail.vue?vue&type=template&id=0f966f5a&scoped=true"
import script from "./salesOrderLineDetail.vue?vue&type=script&lang=js"
export * from "./salesOrderLineDetail.vue?vue&type=script&lang=js"
import style0 from "./salesOrderLineDetail.vue?vue&type=style&index=0&id=0f966f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f966f5a",
  null
  
)

export default component.exports